'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('core-js/modules/web.dom.iterable.js');

const CONSUMERS_CHANNEL_SYMBOL = Symbol("CONSUMERS_CHANNEL_SYMBOL");

const channelMap = {};
const getChannelSingleton = _ref => {
  let {
    key
  } = _ref;

  if (!channelMap[key]) {
    channelMap[key] = new MessageChannel();
  }

  return channelMap[key];
};

const getChannel = () => {
  const {
    port1: publicPort,
    port2: privatePort
  } = getChannelSingleton({
    key: CONSUMERS_CHANNEL_SYMBOL
  });
  return {
    publicPort,
    privatePort
  };
};

const IFRAME_CHANNEL_SYMBOL = Symbol("IFRAME_CHANNEL_SYMBOL");
const IFRAME_ID = "secure-script-container";
const RECEIVER_URL_TEMPLATE = "https://${containerDomain}/receiver_browse.html";

const getChannel$1 = () => {
  const {
    port1: localPort,
    port2: remotePort
  } = getChannelSingleton({
    key: IFRAME_CHANNEL_SYMBOL
  });
  return {
    localPort,
    remotePort
  };
};

const getOriginFromUrl = url => {
  const [scheme,, host] = url.split("/");
  return "".concat(scheme, "//").concat(host);
};

const loadRemoteAndHandshake = _ref => {
  let {
    containerDomain
  } = _ref;
  const iframe = document.querySelector("#".concat(IFRAME_ID));
  const {
    remotePort
  } = getChannel$1();
  const receiverUrl = RECEIVER_URL_TEMPLATE.replace(/\${containerDomain}/, containerDomain);

  iframe.onload = () => {
    iframe.contentWindow.postMessage(null, getOriginFromUrl(receiverUrl), [remotePort]);
  };

  iframe.src = receiverUrl;
};

const forwardMessages = () => {
  const {
    privatePort
  } = getChannel();
  const {
    localPort
  } = getChannel$1();

  privatePort.onmessage = _ref => {
    let {
      data
    } = _ref;
    return localPort.postMessage(data);
  };
};

const loadRemoteAndHandshake$1 = _ref => {
  let {
    containerDomain
  } = _ref;
  forwardMessages();
  loadRemoteAndHandshake({
    containerDomain
  });
};

const getChannel$2 = () => {
  const {
    publicPort: port
  } = getChannel();
  return {
    port
  };
};

exports.getChannel = getChannel$2;
exports.loadRemoteAndHandshake = loadRemoteAndHandshake$1;
